//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Error',
  props: {
    status: {
      type: Number
    }
  },
  components: {
    PageUiMenu: () => import('@/components/PageUi/Menu'),
    PageUiBar: () => import('@/components/PageUi/Bar'),
    PageUiMask: () => import('@/components/PageUi/Mask'),
  },
  computed: {
    errorTitle() {
      let errorTitle = 'エラーが発生しました'
      switch (this.status) {
        case 404:
          errorTitle =  'ページが見つかりません。'
          break;
        case 500:
          errorTitle = '内部サーバーエラー'
          break;
        case 503:
          errorTitle = 'サービス利用停止'
          break;
        default: break;
      }
      return errorTitle
    },
  },
}
